import { Component, AfterViewInit, OnInit, HostListener } from '@angular/core';
import { AuthService } from './services/auth.service';
import { Router } from '@angular/router';
import { ChannelService, ChannelEvent } from './services/channel.service';
import { ClientService } from './clients-module/services/client.service';
import { ToastrService } from 'ngx-toastr';
import { Subject, Subscription } from 'rxjs';
import { AdverseActionLetterStats, ObjectUpdatePayload, ScreeningLight } from './models/screeningInvite';
import { ScreeningService } from './screening-module/services/screening.service';
import {UserSettingsService} from './users-module/services/user-settings-service';
import { PaymentsService } from './services/payments.service';
import { FileDownloadService } from './services/file-download.service';
import { ApplicantDataService } from './services/applicant-data.service';
import { SupportIssueService } from './issue-tracker/services/support-issue.service';
import { tap } from 'rxjs/internal/operators/tap';
import { ButtonClickEvent } from 'plotly.js';
import { WatchTowerService } from './services/watch-tower.service';
import { SopAssistantService } from './services/sop-assistant.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.less']
})
export class AppComponent implements OnInit, AfterViewInit {
  menuShown : boolean = true;
  showProfileModal : boolean = false;
  listner$ : Subject<any>;
  listner2$ : Subject<any>;
  sub : Subscription;
  rolesLoaded : Subscription;
  clientloaded : Subscription;
  rtck : Subscription;
  token : string;
  audioChime = new Audio('/assets/cashMeOutside.mp3');
  audioDing = new Audio('/assets/ammaro_ding.wav');
  paymentWindow: Window;
  // for inactivity timeout
  userActivityWarning : any;
  userActivityTerminateSession : any;
  userInactive: Subject<any> = new Subject();
  sub2 : Subscription;
  ngAfterViewInit(): void {
     if(!this.auth.loggedInUser && location.href.indexOf('/sso') == -1 && location.href.indexOf('/login') == -1) {
       this.auth.GetLoggedInUser();
     }
  }

  constructor(
    public auth : AuthService,
    private location : Router,
    private channels : ChannelService,
    private clients : ClientService,
    private toast : ToastrService,
    private screenings : ScreeningService,
    private readonly userSettingsService: UserSettingsService,
    private payments : PaymentsService,
    private filedownload : FileDownloadService,
    private appData : ApplicantDataService,
    public issues: SupportIssueService,
    public wtch : WatchTowerService,
    public sopAssistant : SopAssistantService
  ) {
    this.audioChime.load();
    

    this.channels.starting$.subscribe((e: any) => {

      this.channels.subscribeClientToSignalR();

      //NOTE: this is now being handled in the channel svc
      // this.channels.reconnectSubject.subscribe((ev: any) => {
      //   this.channels.subscribeClientToSignalR();
      // });

      this.channels.sub('SupportIssue').subscribe((ev: ChannelEvent) => {
        //on any event, always update the supportIssues for CRA users
        if(this.auth.UserInRole('CRA')) this.issues.fetchSupportIssueCounts();

        if(this.auth.UserInRole('CRA') && ev.data === "IssueCreated") {
          // this.audioChime.play();
        }

        if(this.auth.UserInRole('CRA') && ev.data === "IssueResolved") {
          // this.audioDing.play();
        }       

        if(this.auth.UserInRole('CRA') && ev.data === "IssueAssigned") 
        {
          this.toast.info('A support issue has been assigned to you.', 'Support Issue Assigned', { closeButton: true, disableTimeOut: true });           
        }

      });

    //   this.channels.sub('ScreeningUpdate').subscribe((ev : ChannelEvent) =>{

    //     // in the case of screenings the ChannelEvent.data will be a ClientUpdatePayload where NewValue is the stringified screening.
    //     // otherwise it would be an update that should be processed against an existing screening.
        
    //     if(!this.auth.isAuthenticated) return;
    //     // console.warn('got a screening update', ev.data);

    //     try {
    //       let dta= Object.assign(new ObjectUpdatePayload(), JSON.parse(ev.data));
    //       if(dta.objectName == 'CREATE'){
    //         let scr = Object.assign(new ScreeningLight(),JSON.parse(dta.newValue));
    //         let matches = this.screenings.screenings.filter(s =>{ return s.id == scr.id})
    //         if(matches.length == 0) this.screenings.screenings.push(scr);
    //       }
    //       else  if(dta.objectName == 'CREATE-INVITE'){
    //         let scr = Object.assign(new ScreeningLight(),JSON.parse(dta.newValue));
    //         this.screenings.screenings.push(scr);
    //       }
    //       // else{
    //       //   //console.warn(dta);
    //       //   let matches = this.screenings.screenings.filter(s =>{ return s.id == dta.objectId})
    //       //   //we need to update an existing screening record. p.
    //       //   if(dta.newValue == "true") dta.newValue = true;
    //       //   if(dta.newValue == "false") dta.newValue = false;
    //       //   matches[0][dta.propertyName] = dta.newValue;
    //       // }
    //       if(this.auth.UserInRole('Sound')) this.audioChime.play();
    //   } catch (error) {
    //   }
    //     // this.toast.info(ev.data,'',{ disableTimeOut: true, closeButton: true });
    // });

    // this.rolesLoaded = this.auth.roleFetchComplete.subscribe((roles)=>{
      if(this.auth.UserInRole('CRA'))
      {
       this.channels.joinGroup("cra-updates");
      }

      if(this.auth.UserInRole('Manager') && this.auth.UserInRole('CRA')) {
        console.info('Subbed to MGR channel');
        this.channels.sub("manager-updates").subscribe((ev: ChannelEvent) => 
        {
          this.toast.info(ev.data,'Manager Update',{ disableTimeOut: true, closeButton: true });
        });
      }
    // })

    });

    this.channels.sub('DocReadyDownload').subscribe((ev : ChannelEvent) =>{
      let parsed = JSON.parse(ev.data);
      this.toast.clear();
      if(parsed.error){
        this.toast.error('We ran into an issue generating your PDF. Please contact support if the issue persists.', 'PDF Generation Error', { closeButton: true, disableTimeOut: true });
        return;
      }
      this.screenings.DownloadSupportingDoc(parsed.docId).subscribe(res  => {
        if(res) {
          let filename: string;
          if(this.appData.printReport) {
            filename = `PDF-Report-${this.appData.printReport.applicantName}`;
          } else if(this.screenings.screenings[0].invitationId == parsed.inviteId) {
            filename = `Report ${this.screenings.screenings[0].invitationId} Adverse Action Letter`;
            this.screenings.FetchAALStatsLogs(this.screenings.screenings[0].invitationId).pipe(
              tap(_ => {
                this.screenings.screenings[0].adverseActionLetters = [];
                _.forEach((item: AdverseActionLetterStats) => { this.screenings.screenings[0].adverseActionLetters.push(item)})
              },
              err => {},
              () => {})
            ).subscribe();
          }
          else {
            filename = 'Document'
          }
          this.filedownload.HandleFileDownload(res, 'pdf', filename);
          let datToast = this.toast.success(`${filename} is downloading!`, 'Download Ready.', { closeButton: true, timeOut: 0, extendedTimeOut : 0, tapToDismiss : false });
        } else {
          this.toast.error('Error downloading document!', '', { closeButton: true, disableTimeOut: true });
        }
        this.appData.printReport = undefined;
      },
      error => {
        this.toast.error('Error downloading document!', '', { closeButton: true, disableTimeOut: true });
        this.appData.printReport = undefined;
      });
    });


    // client user broadcast mechanism
    this.channels.sub('portal-broadcast').subscribe(res =>{
      var dta = JSON.parse(res.data);
      if(dta.notify)
        var datToast =this.toast.info(dta.Message, dta.Title , { closeButton: true, timeOut: 0, extendedTimeOut : 0, tapToDismiss : false });
      
      if(dta.hotReload){
        datToast.onTap.subscribe(()=>{
          window.location.reload();
        });
      }

      if(dta.enableWatchTower)
        this.wtch.activated = true
      else
        this.wtch.activated = false;

      if(dta.forceReload){
        window.location.reload();
      }

      if(dta.foceLogout){
        this.auth.logout();
      }
      if(dta.closeTab){
        window.close();
      }
          
    });

    // this.channels.sub('dev-broadcast').subscribe(res =>{
    //   console.debug(res);
          
    // })


    this.userInactive.subscribe(() => {
      this.toast.error('You have been inactive for 10 minutes. After 15 minutes of inactivity, you will be logged off.', 'User Inactive', { closeButton:true, disableTimeOut:true });
      this.setInactivityTerminateSession();
    });
  }

  toggleMenu() {
    this.menuShown = !this.menuShown;
    console.log(this.menuShown);
  }

  ngOnInit(): void {
     this.listner$ = this.auth.userFetchComplete;

     this.sub = this.listner$.subscribe((resp)=>{
        if(resp.status == 401) {
          this.auth.logout('APP Component 401 logout');
        }else{
          this.userSettingsService.FetchUserSettings();
          this.channels.start();
          // this.writeSourcesLog();
          this.issues.fetchSupportIssueCounts();
          this.issues.fetchSupportIssueTypes(true);
        }
      }
     )


    

  }

  killSocket() {
    this.channels.stop();
  }

  writeSourcesLog()
  {
    var sources = [];
    for (var i = 0; i < document.scripts.length; i++) {
      // get a copy of the scripts for this user and log them off to the db
     sources.push(document.scripts[i].src);
   }
   this.auth.WriteSourcesLog(sources);
  }


  win : Window;
  openWindow(){
    this.win = window.open('https://google.com','_blank')
  }

  closeWindow(){
    this.win.close();
  }

  navToScreening(){
    this.win = window.open(`https://screening.residentiq.com/users/list/${this.clients.currentClient.id}`,'_blank')
  }

  toggleModal() : void {
    this.showProfileModal = !this.showProfileModal;
  }

  goToEdit() : void {
    this.toggleModal();
    this.location.navigateByUrl(`users/review`)
  }

  logout(){
    this.auth.isAuthenticated = false;
    this.auth.authed = false;
    this.auth.isInitialized = false;
    this.auth.LogOutUser().subscribe(()=>{},()=>{},()=>{
      this.auth.logout('App Component manual logout');
    });
    
  }

  throwToast(){
    this.toast.info('test message')
  }

  setInactivityWarningTimeout() {
    this.userActivityWarning = setTimeout(() => this.userInactive.next(undefined), 1000*10*60);
  }

  setInactivityTerminateSession() {
    clearTimeout(this.userActivityWarning);
    if(!this.auth.UserInRole('CRA')) this.userActivityTerminateSession = setTimeout(() => this.auth.logout('Inactivity Logout'), 1000*5*60);
    else this.userActivityTerminateSession = setTimeout(() => this.auth.logout('Inactivity Logout'), 60000*180); // 3 hour timeout for a CRA.
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivityWarning);
    clearTimeout(this.userActivityTerminateSession)
    if(this.auth.authed) this.setInactivityWarningTimeout();
  }

  
   @HostListener('window:keydown', ['$event'])listen(event : KeyboardEvent) {
    // Ctrl+Shift+Space toggles the SOP assistant
    if(event.ctrlKey && event.shiftKey && event.code === 'Space' && this.auth.UserInRole('CRA')) {
      event.preventDefault();
      this.sopAssistant.toggle();
      return;
    }
    if(event.ctrlKey && event.altKey && event.keyCode == 68 && this.auth.UserInRole('WatchTower')) {
      if(!this.wtch.isWatcher){
        this.channels.joinGroup("WTR");
        this.wtch.isWatcher = true;
      }
          this.channels.sub('UIUpdate').subscribe((ev : ChannelEvent) =>{
              // this.toast.info(ev.data,'',{ disableTimeOut: true, closeButton: true });
              this.wtch.events.push(JSON.parse(ev.data));
          });
          this.toast.success('listening')
        }
  }

  @HostListener('window:click', ['$event'])clck(event : PointerEvent) {
    if(this.wtch.activated){
      let dta = { 
        trgt : event.target['innerText'],
        un : this.auth.loggedInUser.userName,
        fn : this.auth.loggedInUser.firstName,
        ln : this.auth.loggedInUser.lastName,
        page : this.location.url
      };
      // this.toast.info(JSON.stringify(dta),'Click Fired');
      // if(this.auth.UserInRole('CRA')){
        var evt = new ChannelEvent();
        evt.channelName = 'UIUpdate';
        evt.data = JSON.stringify(dta);
        evt.groupName = 'WTR';
        this.channels.publish_stp(evt);
      // }
    }
   
  }
  title = 'stp-dashboard';

}
